/* ==========================================================================
   FlantSoul · tema Shopify — JS principal
   Réplica del comportamiento del sitio Next v6 sobre el carrito nativo.
   Config global en window.FS (la inyecta layout/theme.liquid).
   ========================================================================== */
(function () {
  "use strict";

  var FS = window.FS || {};
  var t = FS.t || {};
  var d = document;

  function $(sel, ctx) { return (ctx || d).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || d).querySelectorAll(sel)); }

  var reducido = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* Formato de moneda: igual a money() del Next (en-US / USD de la tienda) */
  var fmtMoneda;
  try {
    fmtMoneda = new Intl.NumberFormat("en-US", { style: "currency", currency: FS.moneda || "USD", minimumFractionDigits: 2 });
  } catch (e) { fmtMoneda = null; }
  function dinero(centavos) {
    var n = centavos / 100;
    return fmtMoneda ? fmtMoneda.format(n) : "$" + n.toFixed(2);
  }
  FS.dinero = dinero;

  /* Acepta {{ x }} (locales) y [[x]] (tokens que pasan por Liquid sin romper el
     tokenizador — un '}}' literal dentro de una expresión la cierra antes) */
  function interpolar(plantilla, datos) {
    return String(plantilla || "").replace(/\{\{\s*(\w+)\s*\}\}|\[\[(\w+)\]\]/g, function (m, a, b) {
      var k = a || b;
      return datos[k] != null ? datos[k] : m;
    });
  }
  FS.interpolar = interpolar;

  function escaparHtml(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  FS.escaparHtml = escaparHtml;

  /* Candado de scroll compartido entre overlays */
  var candados = 0;
  function bloquearScroll(si) {
    candados = Math.max(0, candados + (si ? 1 : -1));
    d.documentElement.style.overflow = candados > 0 ? "hidden" : "";
  }

  /* ============================ INTRO ============================ */
  (function intro() {
    var el = $("[data-intro]");
    if (!el) { terminar(); return; }
    var CLAVE = "fs-intro-seen";
    function terminar() {
      d.body.classList.add("fs-intro-done");
      window.dispatchEvent(new Event("fs:intro-done"));
    }
    var visto = false;
    try { visto = sessionStorage.getItem(CLAVE) === "1"; } catch (e) {}
    var saltar = reducido || /[?&]nointro\b/.test(location.search) || visto;
    if (saltar) {
      el.remove();
      terminar();
      return;
    }
    try { sessionStorage.setItem(CLAVE, "1"); } catch (e) {}
    el.hidden = false;
    bloquearScroll(true);
    var timers = [];
    function cerrar(rapido) {
      timers.forEach(clearTimeout);
      terminar();
      el.classList.add("is-done");
      bloquearScroll(false);
      timers.push(setTimeout(function () { el.remove(); }, rapido ? 1200 : 1250));
    }
    timers.push(setTimeout(function () { cerrar(false); }, 2650));
    el.addEventListener("click", function () { cerrar(true); });
  })();

  /* ============================ CURSOR ============================ */
  (function cursor() {
    if (!window.matchMedia("(pointer: fine)").matches || reducido) return;
    var dot = $("[data-cursor-dot]");
    var ring = $("[data-cursor-ring]");
    if (!dot || !ring) return;
    d.body.classList.add("fs-cursor");
    var mx = -100, my = -100, rx = -100, ry = -100;
    function loop() {
      rx += (mx - rx) * 0.16;
      ry += (my - ry) * 0.16;
      dot.style.transform = "translate3d(" + mx + "px," + my + "px,0)";
      ring.style.transform = "translate3d(" + rx + "px," + ry + "px,0)";
      requestAnimationFrame(loop);
    }
    window.addEventListener("pointermove", function (e) {
      mx = e.clientX; my = e.clientY;
      dot.style.opacity = "1"; ring.style.opacity = "1";
    }, { passive: true });
    window.addEventListener("pointerover", function (e) {
      var el = e.target && e.target.closest ? e.target.closest("a, button, [role='button'], input, select, label, summary") : null;
      ring.classList.toggle("is-hover", !!el);
    }, { passive: true });
    d.documentElement.addEventListener("pointerleave", function () {
      dot.style.opacity = "0"; ring.style.opacity = "0";
    });
    requestAnimationFrame(loop);
  })();

  /* ============================ REVEALS ============================ */
  function observarReveals(ctx) {
    var els = $$(".fs-reveal:not(.is-in)", ctx);
    if (!els.length) return;
    if (reducido || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("is-in"); });
      return;
    }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add("is-in");
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });
  }
  FS.observarReveals = observarReveals;
  if (d.body.classList.contains("fs-intro-done")) observarReveals();
  else window.addEventListener("fs:intro-done", function () { observarReveals(); }, { once: true });

  /* ============================ HEADER ============================ */
  (function header() {
    var cab = $("[data-header]");
    if (!cab) return;

    function alScroll() { cab.classList.toggle("is-scrolled", window.scrollY > 8); }
    alScroll();
    window.addEventListener("scroll", alScroll, { passive: true });

    /* Barra de anuncios rotativa */
    var anuncio = $("[data-anuncios]");
    if (anuncio) {
      var mensajes = [];
      try { mensajes = JSON.parse(anuncio.getAttribute("data-anuncios")) || []; } catch (e) {}
      if (mensajes.length > 1 && !reducido) {
        var idx = 0;
        setInterval(function () {
          anuncio.classList.add("is-saliendo");
          setTimeout(function () {
            idx = (idx + 1) % mensajes.length;
            anuncio.textContent = mensajes[idx];
            anuncio.classList.remove("is-saliendo");
          }, 250);
        }, 4500);
      }
    }

    /* Mega menú Comprar (hover + click, el click siempre abre) */
    var mega = $("[data-mega]");
    var btnComprar = $("[data-mega-boton]");
    if (mega && btnComprar) {
      var cerrarTimer = null;
      function abrirMega() {
        clearTimeout(cerrarTimer);
        mega.classList.remove("is-cerrado");
        btnComprar.classList.add("is-abierto");
        btnComprar.setAttribute("aria-expanded", "true");
      }
      function cerrarMega() {
        cerrarTimer = setTimeout(function () {
          mega.classList.add("is-cerrado");
          btnComprar.classList.remove("is-abierto");
          btnComprar.setAttribute("aria-expanded", "false");
        }, 80);
      }
      btnComprar.addEventListener("mouseenter", abrirMega);
      btnComprar.parentElement.addEventListener("mouseleave", cerrarMega);
      mega.addEventListener("mouseenter", abrirMega);
      mega.addEventListener("mouseleave", cerrarMega);
      btnComprar.addEventListener("click", abrirMega);
    }
  })();

  /* ============================ OVERLAYS ============================ */
  function crearOverlay(capa, opciones) {
    opciones = opciones || {};
    if (!capa) return null;
    var abierta = false;
    function fijar(v) {
      if (abierta === v) return;
      abierta = v;
      capa.classList.toggle("is-abierta", v);
      capa.setAttribute("aria-hidden", v ? "false" : "true");
      bloquearScroll(v);
      if (v && opciones.alAbrir) opciones.alAbrir();
      if (!v && opciones.alCerrar) opciones.alCerrar();
    }
    var velo = $(".fs-velo", capa);
    if (velo) velo.addEventListener("click", function () { fijar(false); });
    $$("[data-cerrar]", capa).forEach(function (b) {
      b.addEventListener("click", function () { fijar(false); });
    });
    return { abrir: function () { fijar(true); }, cerrar: function () { fijar(false); }, abierta: function () { return abierta; } };
  }

  var menuMovil = crearOverlay($("[data-movil]"));
  var busqueda = crearOverlay($("[data-busqueda]"), {
    alAbrir: function () {
      var inp = $("[data-busqueda-input]");
      if (inp) setTimeout(function () { inp.focus(); }, 60);
    }
  });

  $$("[data-abrir-movil]").forEach(function (b) {
    b.addEventListener("click", function () { if (menuMovil) menuMovil.abrir(); });
  });
  $$("[data-abrir-busqueda]").forEach(function (b) {
    b.addEventListener("click", function () {
      if (window.FSCart) window.FSCart.cerrar();
      if (busqueda) busqueda.abrir();
    });
  });

  d.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    if (menuMovil) menuMovil.cerrar();
    if (busqueda) busqueda.cerrar();
    if (window.FSCart) window.FSCart.cerrar();
    var guia = $("[data-tallas]");
    if (guia && !guia.hidden) cerrarGuia();
  });

  /* ============================ BÚSQUEDA PREDICTIVA ============================ */
  (function busquedaPredictiva() {
    var input = $("[data-busqueda-input]");
    var caja = $("[data-busqueda-resultados]");
    if (!input || !caja) return;
    var timer = null;
    var ultima = "";

    function urlImagen(src, ancho) {
      if (!src) return "";
      return src + (src.indexOf("?") >= 0 ? "&" : "?") + "width=" + ancho;
    }

    function pintar(datos, q) {
      var productos = (datos && datos.resources && datos.resources.results && datos.resources.results.products) || [];
      if (!productos.length) {
        caja.innerHTML = '<p class="fs-busq__vacio">' + escaparHtml(t.buscar_vacio || "") + "</p>";
        return;
      }
      var html = '<ul class="fs-busq__lista">';
      productos.forEach(function (p) {
        /* gotcha: suggest.json da el precio en unidades ("128.00"), no en centavos */
        var precio = Math.round(parseFloat(p.price || "0") * 100);
        var cap = p.compare_at_price_max ? Math.round(parseFloat(p.compare_at_price_max) * 100) : 0;
        html +=
          '<li><a class="fs-busq__item" href="' + escaparHtml(p.url) + '">' +
          '<img src="' + escaparHtml(urlImagen(p.image, 120)) + '" alt="" width="48" height="64" loading="lazy">' +
          '<span class="fs-busq__nombre">' + escaparHtml(p.title) + "</span>" +
          '<span class="fs-busq__precio tabular">' +
          (cap > precio ? "<s>" + dinero(cap) + "</s>" : "") +
          dinero(precio) +
          "</span></a></li>";
      });
      html += "</ul>";
      html +=
        '<a class="fs-busq__ver-todo" href="' + (FS.rutas.buscar || "/search") +
        "?q=" + encodeURIComponent(q) + '&type=product">' + escaparHtml(t.buscar_ver_todo || "") + " →</a>";
      caja.innerHTML = html;
    }

    input.addEventListener("input", function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { caja.innerHTML = ""; ultima = ""; return; }
      timer = setTimeout(function () {
        if (q === ultima) return;
        ultima = q;
        var url = (FS.rutas.sugerencias || "/search/suggest.json") +
          "?q=" + encodeURIComponent(q) +
          "&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag";
        fetch(url)
          .then(function (r) { return r.json(); })
          .then(function (datos) { if (input.value.trim() === q) pintar(datos, q); })
          .catch(function () {});
      }, 180);
    });
  })();

  /* ============================ CARRITO (drawer AJAX) ============================ */
  var Carrito = (function () {
    var capa = $("[data-carro]");
    var overlay = crearOverlay(capa);
    var cuerpo = capa ? $("[data-carro-cuerpo]", capa) : null;
    var estado = null;

    function badge(n) {
      $$("[data-carro-badge]").forEach(function (b) {
        b.textContent = n;
        if (n > 0) b.removeAttribute("data-cero");
        else b.setAttribute("data-cero", "");
      });
      $$("[data-abrir-carro]").forEach(function (b) {
        b.setAttribute("aria-label", interpolar(t.abrir_carrito || "Cart ({{ count }})", { count: n }));
      });
    }

    function pintar() {
      if (!cuerpo) return;
      var c = estado;
      if (!c) return;
      badge(c.item_count);
      var libre = FS.envioGratis || 10000;
      var falta = Math.max(0, libre - c.items_subtotal_price);
      var progreso = Math.min(100, (c.items_subtotal_price / libre) * 100);
      var html =
        '<div class="fs-carro__envio"><p>' +
        (falta > 0
          ? interpolar(t.faltan_html || "", { amount: dinero(falta) })
          : "<strong>" + escaparHtml(t.envio_logrado || "") + "</strong> 🎉") +
        '</p><div class="fs-carro__barra"><div style="width:' + progreso + '%"></div></div></div>';

      if (!c.items.length) {
        html +=
          '<div class="fs-carro__vacio">' +
          '<p class="fs-carro__vacio-titulo">' + escaparHtml(t.vacio_titulo || "") + "</p>" +
          "<p>" + escaparHtml(t.vacio_cuerpo || "") + "</p>" +
          '<a class="btn-ink" data-cerrar href="' + (FS.rutas.newdrop || "/") + '">' + escaparHtml(t.vacio_cta || "") + "</a>" +
          "</div>";
      } else {
        html += '<ul class="fs-carro__lista">';
        c.items.forEach(function (it) {
          var foto = it.image ? urlAncho(it.image, 160) : "";
          html +=
            "<li>" +
            '<a class="fs-carro__foto" data-cerrar href="' + escaparHtml(it.url) + '">' +
            (foto ? '<img src="' + escaparHtml(foto) + '" alt="" width="72" height="96">' : "") +
            "</a>" +
            '<div class="fs-carro__info">' +
            '<a class="fs-carro__nombre" data-cerrar href="' + escaparHtml(it.url) + '">' + escaparHtml(it.product_title) + "</a>" +
            (it.variant_title && it.variant_title !== "Default Title"
              ? '<p class="fs-carro__variante">' + escaparHtml(it.variant_title) + "</p>"
              : "") +
            '<div class="fs-carro__fila">' +
            '<div class="fs-carro__qty">' +
            '<button type="button" data-qty="-1" data-linea-id="' + it.key + '" aria-label="' + escaparHtml(interpolar(t.quitar_uno || "", { title: it.product_title })) + '">−</button>' +
            '<span class="tabular">' + it.quantity + "</span>" +
            '<button type="button" data-qty="1" data-linea-id="' + it.key + '" aria-label="' + escaparHtml(interpolar(t.agregar_uno || "", { title: it.product_title })) + '">+</button>' +
            "</div>" +
            '<p class="fs-carro__linea-precio tabular">' + dinero(it.final_line_price) + "</p>" +
            "</div></div>" +
            '<button type="button" class="fs-carro__quitar" data-quitar data-linea-id="' + it.key + '" aria-label="' + escaparHtml(interpolar(t.eliminar || "", { title: it.product_title })) + '">' +
            '<svg width="16" height="16" viewBox="0 0 20 20" aria-hidden="true"><path d="M4 4l12 12M16 4L4 16" stroke="currentColor" stroke-width="1.4"/></svg>' +
            "</button></li>";
        });
        html += "</ul>";
        html +=
          '<div class="fs-carro__pie">' +
          '<p class="fs-carro__escasez"><svg width="13" height="13" viewBox="0 0 10 10" aria-hidden="true"><path d="M5 0l1.2 3.8L10 5 6.2 6.2 5 10 3.8 6.2 0 5l3.8-1.2Z" fill="currentColor"/></svg>' +
          escaparHtml(t.escasez || "") + "</p>" +
          '<div class="fs-carro__subtotal"><p>' + escaparHtml(t.subtotal || "Subtotal") + '</p><p class="tabular">' + dinero(c.items_subtotal_price) + "</p></div>" +
          '<p class="fs-carro__nota">' + escaparHtml(t.impuestos || "") + "</p>" +
          '<a class="btn-ink btn-bloque" href="' + (FS.rutas.checkout || "/checkout") + '">' + escaparHtml(t.pagar || "") + "</a>" +
          '<button type="button" class="fs-carro__seguir" data-cerrar>' + escaparHtml(t.seguir || "") + "</button>" +
          "</div>";
      }
      cuerpo.innerHTML = html;
      $$("[data-cerrar]", cuerpo).forEach(function (b) {
        b.addEventListener("click", function () { overlay.cerrar(); });
      });
      $$("[data-qty]", cuerpo).forEach(function (b) {
        b.addEventListener("click", function () {
          var linea = b.getAttribute("data-linea-id");
          var it = estado.items.filter(function (x) { return x.key === linea; })[0];
          if (!it) return;
          cambiar(linea, it.quantity + parseInt(b.getAttribute("data-qty"), 10));
        });
      });
      $$("[data-quitar]", cuerpo).forEach(function (b) {
        b.addEventListener("click", function () { cambiar(b.getAttribute("data-linea-id"), 0); });
      });
    }

    function urlAncho(src, w) {
      return src + (src.indexOf("?") >= 0 ? "&" : "?") + "width=" + w;
    }

    function refrescar() {
      return fetch(FS.rutas.carrito || "/cart.js")
        .then(function (r) { return r.json(); })
        .then(function (c) { estado = c; pintar(); return c; })
        .catch(function () {});
    }

    function cambiar(linea, qty) {
      return fetch(FS.rutas.carritoCambiar || "/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: linea, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (c) { estado = c; pintar(); })
        .catch(function () {});
    }

    function agregar(variantId, qty) {
      return fetch(FS.rutas.carritoAgregar || "/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: qty || 1 })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      });
    }

    $$("[data-abrir-carro]").forEach(function (b) {
      b.addEventListener("click", function () {
        if (busqueda) busqueda.cerrar();
        /* refrescar al abrir: el carrito pudo cambiar por fuera (gotcha BOHOR) */
        refrescar().then(function () { overlay.abrir(); });
      });
    });

    refrescar();

    return {
      abrir: function () { refrescar().then(function () { overlay.abrir(); }); },
      cerrar: function () { if (overlay) overlay.cerrar(); },
      refrescar: refrescar,
      agregar: agregar
    };
  })();
  window.FSCart = Carrito;

  /* ============================ GUÍA DE TALLAS ============================ */
  var guiaEl = $("[data-tallas]");
  function abrirGuia() {
    if (!guiaEl) return;
    guiaEl.hidden = false;
    bloquearScroll(true);
    var btn = $("[data-cerrar-tallas]", guiaEl);
    if (btn) btn.focus();
  }
  function cerrarGuia() {
    if (!guiaEl || guiaEl.hidden) return;
    guiaEl.hidden = true;
    bloquearScroll(false);
  }
  if (guiaEl) {
    var veloGuia = $(".fs-velo", guiaEl);
    if (veloGuia) veloGuia.addEventListener("click", cerrarGuia);
    var btnCerrarGuia = $("[data-cerrar-tallas]", guiaEl);
    if (btnCerrarGuia) btnCerrarGuia.addEventListener("click", cerrarGuia);
  }
  d.addEventListener("click", function (e) {
    var abridor = e.target && e.target.closest ? e.target.closest("[data-guia-tallas]") : null;
    if (abridor) {
      e.preventDefault();
      abrirGuia();
    }
  });
  window.addEventListener("fs:sizeguide", abrirGuia);

  /* ============================ HERO CARRUSEL ============================ */
  (function hero() {
    var raiz = $("[data-hero]");
    if (!raiz) return;
    var slides = $$("[data-hero-slide]", raiz);
    var puntos = $$("[data-hero-punto]", raiz);
    if (slides.length < 2) return;
    var i = 0;
    var pausado = false;
    var arrastre = null;

    function fijar(n) {
      i = ((n % slides.length) + slides.length) % slides.length;
      slides.forEach(function (s, idx) {
        var activa = idx === i;
        s.classList.toggle("is-activa", activa);
        s.setAttribute("aria-hidden", activa ? "false" : "true");
        if (activa) s.removeAttribute("inert");
        else s.setAttribute("inert", "");
      });
      puntos.forEach(function (p, idx) {
        p.setAttribute("aria-current", idx === i ? "true" : "false");
      });
    }

    if (!reducido) {
      setInterval(function () {
        if (!pausado && !d.hidden) fijar(i + 1);
      }, 7000);
    }
    raiz.addEventListener("mouseenter", function () { pausado = true; });
    raiz.addEventListener("mouseleave", function () { pausado = false; });
    raiz.addEventListener("focusin", function () { pausado = true; });
    raiz.addEventListener("focusout", function () { pausado = false; });
    raiz.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight") fijar(i + 1);
      if (e.key === "ArrowLeft") fijar(i - 1);
    });
    raiz.addEventListener("pointerdown", function (e) {
      arrastre = { x: e.clientX, y: e.clientY };
    });
    raiz.addEventListener("pointerup", function (e) {
      if (!arrastre) return;
      var dx = e.clientX - arrastre.x;
      var dy = e.clientY - arrastre.y;
      arrastre = null;
      if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy)) fijar(i + (dx < 0 ? 1 : -1));
    });
    $$("[data-hero-flecha]", raiz).forEach(function (b) {
      b.addEventListener("click", function () {
        fijar(i + (b.getAttribute("data-hero-flecha") === "sig" ? 1 : -1));
      });
    });
    puntos.forEach(function (p, idx) {
      p.addEventListener("click", function () { fijar(idx); });
    });
    fijar(0);
  })();

  /* ============================ RIELES ============================ */
  function iniciarRieles(ctx) {
    $$("[data-rail]", ctx).forEach(function (rail) {
      if (rail.getAttribute("data-rail-listo")) return;
      rail.setAttribute("data-rail-listo", "1");
      var pista = $("[data-rail-pista]", rail);
      var ant = $("[data-rail-ant]", rail);
      var sig = $("[data-rail-sig]", rail);
      if (!pista || !ant || !sig) return;
      function refrescar() {
        ant.disabled = pista.scrollLeft <= 10;
        sig.disabled = pista.scrollLeft >= pista.scrollWidth - pista.clientWidth - 10;
      }
      function mover(dir) {
        pista.scrollBy({ left: dir * pista.clientWidth * 0.8, behavior: "smooth" });
      }
      ant.addEventListener("click", function () { mover(-1); });
      sig.addEventListener("click", function () { mover(1); });
      pista.addEventListener("scroll", refrescar, { passive: true });
      if ("ResizeObserver" in window) new ResizeObserver(refrescar).observe(pista);
      refrescar();
    });
  }
  FS.iniciarRieles = iniciarRieles;
  iniciarRieles();

  /* ============================ ACORDEONES ============================ */
  function iniciarAcordeones(raiz, unicos) {
    var botones = $$("[data-acordeon]", raiz);
    botones.forEach(function (b) {
      b.addEventListener("click", function () {
        var cuerpo = d.getElementById(b.getAttribute("aria-controls"));
        var abierto = b.getAttribute("aria-expanded") === "true";
        if (unicos) {
          botones.forEach(function (o) {
            o.setAttribute("aria-expanded", "false");
            var c = d.getElementById(o.getAttribute("aria-controls"));
            if (c) c.hidden = true;
            var s = $("[data-signo]", o);
            if (s) s.textContent = "+";
          });
        }
        b.setAttribute("aria-expanded", abierto ? "false" : "true");
        if (cuerpo) cuerpo.hidden = abierto;
        var signo = $("[data-signo]", b);
        if (signo) signo.textContent = abierto ? "+" : "−";
      });
    });
  }
  $$("[data-acordeones]").forEach(function (grupo) {
    iniciarAcordeones(grupo, grupo.getAttribute("data-acordeones") === "unicos");
  });

  /* ============================ PLP: filtros en cliente ============================ */
  (function plp() {
    var raiz = $("[data-plp]");
    if (!raiz) return;
    var grid = $("[data-plp-grid]", raiz);
    var items = $$("[data-plp-item]", grid);
    if (!items.length) return;

    var datos = items.map(function (li, pos) {
      return {
        el: li,
        pos: pos,
        tallas: (li.getAttribute("data-tallas") || "").split("||").filter(Boolean),
        colores: (li.getAttribute("data-colores") || "").split("||").filter(Boolean),
        oferta: li.getAttribute("data-oferta") === "1",
        precio: parseInt(li.getAttribute("data-precio") || "0", 10)
      };
    });

    /* chips de talla: orden de aparición, máx 8 (igual que el Next) */
    var tallas = [];
    datos.forEach(function (x) {
      x.tallas.forEach(function (s) { if (tallas.indexOf(s) < 0) tallas.push(s); });
    });
    tallas = tallas.slice(0, 8);

    /* chips de color: top 10 por frecuencia */
    var cuentaColores = {};
    datos.forEach(function (x) {
      x.colores.forEach(function (c) { cuentaColores[c] = (cuentaColores[c] || 0) + 1; });
    });
    var colores = Object.keys(cuentaColores)
      .sort(function (a, b) { return cuentaColores[b] - cuentaColores[a]; })
      .slice(0, 10);

    var estado = { talla: null, color: null, oferta: false, orden: "new" };

    function chip(texto, presionado) {
      var b = d.createElement("button");
      b.type = "button";
      b.className = "fs-chip";
      b.textContent = texto;
      b.setAttribute("aria-pressed", presionado ? "true" : "false");
      return b;
    }

    var zonaTallas = $("[data-plp-tallas]", raiz);
    if (zonaTallas && tallas.length > 1) {
      zonaTallas.hidden = false;
      tallas.forEach(function (s) {
        var b = chip(s, false);
        b.addEventListener("click", function () {
          estado.talla = estado.talla === s ? null : s;
          aplicar();
        });
        b.setAttribute("data-valor", s);
        zonaTallas.appendChild(b);
      });
    }
    var zonaColores = $("[data-plp-colores]", raiz);
    if (zonaColores && colores.length > 1) {
      zonaColores.hidden = false;
      colores.forEach(function (c) {
        var b = chip(c, false);
        b.addEventListener("click", function () {
          estado.color = estado.color === c ? null : c;
          aplicar();
        });
        b.setAttribute("data-valor", c);
        zonaColores.appendChild(b);
      });
    }
    var btnOferta = $("[data-plp-oferta]", raiz);
    if (btnOferta) {
      btnOferta.addEventListener("click", function () {
        estado.oferta = !estado.oferta;
        aplicar();
      });
    }
    var selOrden = $("[data-plp-orden]", raiz);
    if (selOrden) {
      selOrden.addEventListener("change", function () {
        estado.orden = selOrden.value;
        aplicar();
      });
    }
    var btnLimpiar = $("[data-plp-limpiar]", raiz);
    if (btnLimpiar) {
      btnLimpiar.addEventListener("click", function () {
        estado.talla = null; estado.color = null; estado.oferta = false;
        aplicar();
      });
    }

    var cuenta = $("[data-plp-cuenta]", raiz);
    var vacio = $("[data-plp-vacio]", raiz);
    var plurales = t.piezas || { one: "{{ count }} piece", other: "{{ count }} pieces" };

    function aplicar() {
      if (zonaTallas) $$(".fs-chip", zonaTallas).forEach(function (b) {
        var activo = b.getAttribute("data-valor") === estado.talla;
        b.classList.toggle("is-activo", activo);
        b.setAttribute("aria-pressed", activo ? "true" : "false");
      });
      if (zonaColores) $$(".fs-chip", zonaColores).forEach(function (b) {
        var activo = b.getAttribute("data-valor") === estado.color;
        b.classList.toggle("is-activo", activo);
        b.setAttribute("aria-pressed", activo ? "true" : "false");
      });
      if (btnOferta) {
        btnOferta.classList.toggle("is-activo", estado.oferta);
        btnOferta.setAttribute("aria-pressed", estado.oferta ? "true" : "false");
      }

      var visibles = datos.filter(function (x) {
        return (!estado.talla || x.tallas.indexOf(estado.talla) >= 0) &&
          (!estado.color || x.colores.indexOf(estado.color) >= 0) &&
          (!estado.oferta || x.oferta);
      });
      var orden = visibles.slice();
      if (estado.orden === "price-asc") orden.sort(function (a, b) { return a.precio - b.precio; });
      if (estado.orden === "price-desc") orden.sort(function (a, b) { return b.precio - a.precio; });
      if (estado.orden === "new") orden.sort(function (a, b) { return a.pos - b.pos; });

      datos.forEach(function (x) { x.el.hidden = visibles.indexOf(x) < 0; });
      orden.forEach(function (x) { grid.appendChild(x.el); });

      if (cuenta) {
        cuenta.textContent = interpolar(visibles.length === 1 ? plurales.one : plurales.other, { count: visibles.length });
      }
      if (vacio) vacio.hidden = visibles.length > 0;
      grid.hidden = visibles.length === 0;
    }
    aplicar();
  })();

  /* ============================ PDP ============================ */
  (function pdp() {
    var raiz = $("[data-pdp]");
    if (!raiz) return;
    var datosEl = $("[data-producto-json]", raiz);
    if (!datosEl) return;
    var producto;
    try { producto = JSON.parse(datosEl.textContent); } catch (e) { return; }

    var opciones = producto.options || [];
    var sel = {};
    opciones.forEach(function (o, idx) {
      var pre = raiz.getAttribute("data-preseleccion-" + (idx + 1));
      sel[o] = pre || null;
    });
    /* primera variante como estado inicial (igual que el Next: primer valor de cada opción) */
    opciones.forEach(function (o, idx) {
      if (!sel[o]) {
        var valores = [];
        producto.variants.forEach(function (v) {
          var val = idx === 0 ? v.option1 : idx === 1 ? v.option2 : v.option3;
          if (val && valores.indexOf(val) < 0) valores.push(val);
        });
        sel[o] = valores[0];
      }
    });
    /* si el servidor dejó una selección pintada, se respeta (paridad de primer paint) */
    $$("[data-opcion-btn].is-activo", raiz).forEach(function (b) {
      sel[b.getAttribute("data-opcion")] = b.getAttribute("data-valor");
    });

    function variantePara() {
      var elegida = producto.variants.filter(function (v) {
        return opciones.every(function (o, idx) {
          var val = idx === 0 ? v.option1 : idx === 1 ? v.option2 : v.option3;
          return val === sel[o];
        });
      })[0];
      return elegida || producto.variants[0];
    }

    function opcionDisponible(nombre, valor) {
      var idx = opciones.indexOf(nombre);
      return producto.variants.some(function (v) {
        var mio = idx === 0 ? v.option1 : idx === 1 ? v.option2 : v.option3;
        if (mio !== valor) return false;
        var otraIdx = idx === 0 ? 1 : 0;
        var otra = opciones[otraIdx];
        if (!otra) return v.available;
        var suyo = otraIdx === 0 ? v.option1 : v.option2;
        return v.available && suyo === sel[otra];
      });
    }

    var precioEl = $("[data-pdp-precio]", raiz);
    var ahorroEl = $("[data-pdp-ahorro]", raiz);
    var ctasEl = $("[data-pdp-ctas]", raiz);
    var offEl = $("[data-pdp-off]", raiz);

    function pintarEstado() {
      var v = variantePara();
      var off = v.compare_at_price && v.compare_at_price > v.price
        ? Math.round((1 - v.price / v.compare_at_price) * 100)
        : 0;

      $$("[data-opcion-btn]", raiz).forEach(function (b) {
        var nombre = b.getAttribute("data-opcion");
        var valor = b.getAttribute("data-valor");
        var activo = sel[nombre] === valor;
        b.classList.toggle("is-activo", activo);
        b.setAttribute("aria-pressed", activo ? "true" : "false");
        b.classList.toggle("no-disponible", !opcionDisponible(nombre, valor));
      });
      $$("[data-opcion-valor]", raiz).forEach(function (s) {
        s.textContent = sel[s.getAttribute("data-opcion-valor")] || "";
      });

      if (precioEl) {
        precioEl.innerHTML =
          (v.compare_at_price && v.compare_at_price > v.price ? "<s>" + dinero(v.compare_at_price) + "</s> " : "") +
          '<span class="' + (off > 0 ? "es-oferta" : "") + '">' + dinero(v.price) + "</span>";
      }
      if (ahorroEl) {
        if (off > 0 && v.compare_at_price) {
          ahorroEl.hidden = false;
          ahorroEl.textContent = interpolar(t.ahorras || "", { amount: dinero(v.compare_at_price - v.price) });
        } else ahorroEl.hidden = true;
      }
      if (offEl) {
        offEl.hidden = off <= 0;
        offEl.textContent = "−" + off + "%";
      }

      if (ctasEl) {
        if (v.available) {
          ctasEl.innerHTML =
            '<button type="button" class="btn-ink btn-bloque" data-pdp-agregar>' +
            escaparHtml(t.agregar || "") + " — " + dinero(v.price) +
            "</button>" +
            '<a class="btn-ghost btn-bloque" href="' + (FS.rutas.raiz || "/") + "cart/" + v.id + ':1">' +
            escaparHtml(t.comprar_ahora || "") + "</a>";
          var btn = $("[data-pdp-agregar]", ctasEl);
          btn.addEventListener("click", function () {
            btn.disabled = true;
            Carrito.agregar(v.id, 1)
              .then(function () { Carrito.abrir(); })
              .catch(function () {})
              .then(function () { btn.disabled = false; });
          });
        } else {
          var msgWa = interpolar(t.wa_restock || "", { title: producto.title, variant: v.title });
          ctasEl.innerHTML =
            '<p class="fs-pdp__agotado-aviso">' + escaparHtml(t.combo_agotado || "") + "</p>" +
            '<a class="btn-ghost btn-bloque" target="_blank" rel="noopener noreferrer" href="https://wa.me/' +
            (FS.whatsapp || "") + "?text=" + encodeURIComponent(msgWa) + '">' +
            escaparHtml(t.avisame || "") + "</a>";
        }
      }
    }

    $$("[data-opcion-btn]", raiz).forEach(function (b) {
      b.addEventListener("click", function () {
        sel[b.getAttribute("data-opcion")] = b.getAttribute("data-valor");
        pintarEstado();
      });
    });
    pintarEstado();

    /* Galería */
    var principal = $("[data-galeria-principal]", raiz);
    $$("[data-galeria-mini]", raiz).forEach(function (mini) {
      mini.addEventListener("click", function () {
        if (principal) {
          principal.src = mini.getAttribute("data-src-grande");
          principal.srcset = mini.getAttribute("data-srcset-grande") || "";
          principal.alt = mini.getAttribute("data-alt-grande") || "";
        }
        $$("[data-galeria-mini]", raiz).forEach(function (m) {
          m.setAttribute("aria-current", m === mini ? "true" : "false");
        });
      });
    });
  })();

  /* ============================ CONTACTO → WHATSAPP ============================ */
  (function contactoWa() {
    var form = $("[data-wa-form]");
    if (!form) return;
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var nombre = (form.querySelector("[name='nombre']") || {}).value || "";
      var msg = (form.querySelector("[name='mensaje']") || {}).value || "";
      if (!nombre.trim()) nombre = form.getAttribute("data-clienta") || "";
      var texto = (form.getAttribute("data-plantilla") || "")
        .replace("__NOMBRE__", nombre.trim())
        .replace("__MSG__", msg.trim());
      var url = "https://wa.me/" + form.getAttribute("data-wa") + "?text=" + encodeURIComponent(texto);
      window.open(url, "_blank", "noopener,noreferrer");
    });
  })();

  /* Re-inicializar dentro del editor de temas */
  d.addEventListener("shopify:section:load", function (e) {
    iniciarRieles(e.target);
    observarReveals(e.target);
  });
})();
